<template>
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="auto">
          <h6 class="m-0">Informações da negociação</h6>
        </d-col>
      </d-row>
    </d-card-header>

     <d-card-body class="d-flex flex-column">
      <no-permission v-if="isCustomer" />
      <template v-else>
        <d-form @submit="save" class="d-flex flex-fill flex-column" v-if="model.deal">
          <d-form-row>
            <!-- Team Instalation  -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Equipe de instalação</label>
              <d-select v-model="model.deal.deals.team" :state="hasErrorFiled('team')">
                <option value="Incluso clt">Incluso CLT</option>
                <option value="Incluso contrato">Incluso Contrato</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Equipe de instalação é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Food -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Alimentação</label>
              <d-select v-model="model.deal.deals.food" :state="hasErrorFiled('food')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
              </d-select>
              <d-form-invalid-feedback>Alimentação é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Accommodation -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Hospedagem</label>
              <d-select v-model="model.deal.deals.accommodation" :state="hasErrorFiled('accommodation')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
              </d-select>
              <d-form-invalid-feedback>Hospedagem é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Shipping -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Frete</label>
              <d-select v-model="model.deal.deals.shipping" :state="hasErrorFiled('shipping')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Frete é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Sub Floor  -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Construção de contra-piso</label>
              <d-select v-model="model.deal.deals.sub_floor" :state="hasErrorFiled('sub_floor')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Construção de contra-piso é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Grass Removal -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Remoção de grama</label>
              <d-select v-model="model.deal.deals.grass_removal" :state="hasErrorFiled('grass_removal')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Remoção de grama é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Earthwork -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Terraplanagem</label>
              <d-select v-model="model.deal.deals.earthwork" :state="hasErrorFiled('earthwork')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Terraplanagem é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Earthwork Tool -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Maquinários</label>
              <d-select v-model="model.deal.deals.earthwork_tool" :state="hasErrorFiled('earthwork_tool')">
                <option value="Nenhum">Nenhum</option>
                <option value="Bobcat">Bobcat</option>
                <option value="Bobcat e rolo compactador">Bobcat e rolo compactador</option>
                <option value="Rolo compactador">Rolo compactador</option>
                <option value="Bobcat e Placa vibratória">Bobcat e Placa vibratória</option>
                <option value="Placa vibratória">Placa vibratória</option>
              </d-select>
              <d-form-invalid-feedback>Maquinários é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Floor Adjustments  -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Acerto de piso</label>
              <d-select v-model="model.deal.deals.floor_adjustments" :state="hasErrorFiled('floor_adjustments')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Acerto de piso é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Washed Sand -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Areia fina lavada</label>
              <d-select v-model="model.deal.deals.washed_sand" :state="hasErrorFiled('washed_sand')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Areia fina lavada é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Sand Common-->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Areia comum</label>
              <d-select v-model="model.deal.deals.common_sand" :state="hasErrorFiled('common_sand')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Areia comum é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Tools -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Ferramentas</label>
              <d-select v-model="model.deal.deals.tools" :state="hasErrorFiled('tools')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Ferramentas é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <d-form-row v-if="model.deal.deals.tools === 'Incluso'">
            <!-- Tool type -->
            <d-col cols="12" class="form-group">
              <label for="name">Tipo de ferramentas</label>
              <d-form-input
                type="text"
                class="text-left"
                placeholder="Ex.: Pá, carrinho de mão, enxada...."
                v-model="model.deal.deals.tool_type"
                :state="hasErrorFiled('tool_type')"
              />
              <d-form-invalid-feedback>Tipo de ferramentas é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Scaffolding  -->
            <d-col cols="12" md="3" class="form-group ">
              <label for="name">Andaime</label>
              <d-select v-model="model.deal.deals.scaffolding" :state="hasErrorFiled('scaffolding')">
                <option value="Incluso">Incluso</option>
                <option value="Não Incluso">Não Incluso</option>
                <option value="A definir">A definir</option>
              </d-select>
              <d-form-invalid-feedback>Andaime é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Floor Type -->
            <d-col cols="12" md="3" class="form-group ">
              <label for="name">Tipo de piso</label>
              <d-select v-model="model.deal.deals.floor_type" :state="hasErrorFiled('floor_type')">
                <option value="Não drenante">Não drenante</option>
                <option value="Drenante">Drenante</option>
              </d-select>
              <d-form-invalid-feedback>Tipo de piso é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Displacement -->
            <d-col cols="12" md="3" class="form-group ">
              <label for="name">Deslocamento</label>
              <d-select v-model="model.deal.deals.displacement" :state="hasErrorFiled('displacement')">
                <option value="Não">Não</option>
                <option value="Sim">Sim</option>
              </d-select>
              <d-form-invalid-feedback>Tipo de piso é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <d-form-row>
           <!-- Comment -->
            <d-col cols="12" class="form-group ">
              <label for="name">Comentários:</label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Comentário..."
                v-model="model.deal.deals.comment"
                rows="5"
                ></textarea>
            </d-col>
          </d-form-row>
        </d-form>
      </template>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <button class="btn btn-success" @click="save">Salvar e avançar</button>
        </d-col>
      </d-form-row>

    </d-card-body>

  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import MixinValidateForm from '_common/mixins/ValidateForm';
import QuotationService from '_services/rest/modules/quotation';
import NoPermission from './NoPermission.vue';
import { MODEL, DEAL, _LOAD_MODEL_ } from './QuotationModel';

export default {
  name: 'Step-deal',
  mixins: [MixinValidateForm],
  data() {
    return {
      model: cloneDeep(MODEL),
      errors: {
        team: { required: false },
        food: { required: false },
        tools: { required: false },
        shipping: { required: false },
        sub_floor: { required: false },
        earthwork: { required: false },
        floor_type: { required: false },
        scaffolding: { required: false },
        common_sand: { required: false },
        washed_sand: { required: false },
        accommodation: { required: false },
        grass_removal: { required: false },
        earthwork_tool: { required: false },
        floor_adjustments: { required: false },
        displacement: { required: false },
      },
    };
  },
  computed: {
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
  },
  components: {
    NoPermission,
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    save() {
      if (this.checkDealForm()) {
        this.model.step = 'deal';
        this.model.deal.quotation_id = this.model.id;
        QuotationService.updateQuotation(this.model)
          .then(response => {
            this.$store.commit('setQuotation', response);
            Events.$emit(_LOAD_MODEL_, response);
            this.$router.push({ name: 'admin-quotation-installation', params: { quotationId: response.id } });
          });
      }
    },
    checkDealForm() {
      this.submitted = true;
      let valid = true;
      if (this.model.service.service_type === 'Fornecimento') {
        delete this.errors;
        this.errors = { shipping: { required: false } };
      }
      if (this.model.deal.deals.tools === 'Incluso') {
        Object.assign(this.errors, { tool_type: { required: false } });
      } else {
        delete this.errors.tool_type;
      }
      Object.keys(this.model.deal.deals).forEach(field => {
        if (this.errors[field]) {
          this.errors[field].required = false;
          if (!this.model.deal.deals[field]) {
            this.errors[field].required = true;
            valid = false;
          }
        }
      });
      return valid;
    },
    loadModel(quotation) {
      if (quotation) {
        this.model = quotation;
      }
      if (!this.model.deal) {
        this.model.deal = cloneDeep(DEAL);
      }
    },
  },
  mounted() {
    const { quotation } = this.$store.state.quotation;
    this.loadModel(quotation);
    Events.$on(_LOAD_MODEL_, model => {
      this.loadModel(model);
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
